module.exports = __webpack_public_path__ + "img/icon_12.bb4f3902.png";